import { styled } from 'styled-components'

import { useAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { downloadFile } from '@b-stock/fe-core/bstock-next/helpers'
import { useSavedFiles } from '@b-stock/fe-core/bstock-next/hooks'
import { FormattedMessage, FileInfoLine } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'
import type { MediaDto } from '@b-stock/listing-api-client'

import { SectionRow } from '@/buyer-portal/components/SectionRow'

const ns = 'Offerings.Details'

const Description = styled.div`
  ${Typography.Body2}
  padding-bottom: 1rem;
`

const FileInfoContainer = styled.div`
  padding: 0.5rem 0;
`

export const ListingAttachments = ({
  documents,
}: {
  documents: MediaDto[]
}) => {
  const accessToken = useAccessToken({ required: true })
  const { data: savedFiles } = useSavedFiles(documents, accessToken)

  return (
    <SectionRow rowPrefix={`${ns}.attachments`}>
      <Description>
        <FormattedMessage
          id={`${ns}.attachments.description`}
          values={{ count: savedFiles.length }}
        />
      </Description>
      {savedFiles.map((file) => {
        return (
          <FileInfoContainer key={file.id}>
            <FileInfoLine
              savedFile={file}
              handleDownload={(file) => {
                void downloadFile({
                  accessToken,
                  id: file.id,
                  filename: file.name,
                })
              }}
            />
          </FileInfoContainer>
        )
      })}
    </SectionRow>
  )
}
